import React, { Component } from 'react';
import SEO from './SEO';
import moment from 'moment';
import _ from 'lodash';
import { InputGroup } from "react-bootstrap";
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from "react-datepicker";
import Spinner from 'react-bootstrap/Spinner';
import Carousel from 'react-bootstrap/Carousel';
import '../modules/global';

// services
import { healthTipService } from '../services/healthTip';
import { doctorService } from '../services/doctor';

import '../assets/styles/HomeNew.scss';
import '../assets/styles/SearchInput.scss';
import main_img from '../assets/images/new-homepage/main-img-2.png';

import Slider from './SliderComponent';

// specialties images
import dentist_img from '../assets/images/new-homepage/specialties/dentist.png'; 
import general_practitioner_img from '../assets/images/new-homepage/specialties/general_practitioner.png'; 
import gastroenterology_and_hepatology_img from '../assets/images/new-homepage/specialties/gastroenterology_and_hepatology.png'; 
import obstetrics_and_gynaecology_img from '../assets/images/new-homepage/specialties/obstetrics_and_gynaecology.png'; 
import ophthalmology_img from '../assets/images/new-homepage/specialties/ophthalmology.png'; 
import ear_nose_throat_img from '../assets/images/new-homepage/specialties/ear_nose_throat.png'; 

// healthcare professionals images
import locationIcon from '../assets/images/new-homepage/location-icon.png'; 
import calendarIcon from '../assets/images/new-homepage/calendar-icon.png'; 
import default_avatar from '../assets/images/avatar-default.png';
import rightIcon from '../assets/images/right-icon.png';

// list your practices images
import practice_img from '../assets/images/new-homepage/list-your-practice.png'; 

import HomeMap from "./HomeMap";

class Home extends Component {
  constructor(props){
    super(props);

    this.state = {
        expert_column_items: [],
        specialties: [],
        startDate: new Date(),
        search_input_value: '',
        selected_specialty: null,
        location: '',
        locations: [],
        defaultLocations: [],
        selected_location_display: '',
        closeLocationField: false,
        states: [],
        selected_state: '',
        metadata: {
          title: 'Search & Book - BookDoc',
          description: 'Search and book an appointment with a doctor or clinic, at any time from wherever you are',
          type: 'website'
        },
        selected_category: 'General Practitioner (GP Doctor)',
        healthcare_professionals: [],
        loading: false,
        map_doctors: [],
        map_loading: false
    }
  }
  specialties = [{
    img: dentist_img,
    name: 'Dentist<br/>(General)'
  },{
    img: general_practitioner_img,
    name: 'General<br/>Practitioner (GP)'
  },{
    img: gastroenterology_and_hepatology_img,
    name: 'Gastroenterology<br/>& Hepatology'
  },{
    img: obstetrics_and_gynaecology_img,
    name: 'Obstetrics &<br/>Gynaecology'
  },{
    img: ophthalmology_img,
    name: 'Ophthalmology<br/>(Eye Doctor)'
  },{
    img: ear_nose_throat_img,
    name: 'Ear, Nose,<br/>and Throat (ENT)'
  }]
  categories = [
    {
      label: 'General Practitioner (GP)',
      value: 'General Practitioner (GP Doctor)'
    },{
      label: 'Dentist',
      value: 'Dentist (General)'
    },{
      label: 'Paediatrics (Child Specialist)',
      value: 'General Paediatrics'
    },{
      label: 'Dermatology (Skin Specialist)',
      value: 'Dermatology'
    },{
      label: 'O&G (Women Specialist)',
      value: 'Obstetrics and Gynaecology (O&G)'
    },{
      label: 'Ophthalmology (Eye Specialist)',
      value: 'Ophthalmology'
    },{
      label: 'Orthopedic (Bone Specialist)',
      value: 'Orthopaedic Surgery'
    },{
      label: 'Cardiology (Heart Specialist)',
      value: 'Cardiology'
    },{
      label: 'Gastroenterology (Stomach Specialist)',
      value: 'Gastroenterology & Hepatology'
    },{
      label: 'Physiotherapy',
      value: 'Physiotherapy'
    },{
      label: 'Otorhinolaryngology (ENT)',
      value: 'Otorhinolaryngology (ENT)'
    },{
      label: 'Clinical Psychology',
      value: 'Clinical Psychology'
    },{
      label: 'Urology',
      value: 'Urology'
    },{
      label: 'and many more...',
      value: 'deeplink'
    }]
  healthcare_professionals = [1,1,1,1]

  componentDidMount(){
    this.getCommons();
    this.getExpertColumns();
    this.handleCategoryChange(this.state.selected_category);
    this.getMapDoctors();

    axios.get(process.env.REACT_APP_API_URL + 'doctors/available_locations', {
      headers: {
        'Accept': 'application/laelia.v2'
      }
    }).then(res => {
      var locations = global.constant.available_countries;
      if (res.data) {
        locations = [{
          label: 'Available Countries',
          type: 'available_country',
          options: res.data.countries.map((country) => {
            return {
              ...country,
              type: 'available_country'
            }
          })
        }]
      }
      if (locations) {
        if ("geolocation" in navigator) {
          navigator.geolocation.getCurrentPosition(function (position) {
              var checkLocExist = locations.findIndex(x => x.type === 'current_location')
              if (checkLocExist < 0) {
                locations.unshift({
                  name: 'Current Location',
                  lat: position.coords.latitude,
                  long: position.coords.longitude,
                  type: 'current_location'
                });
              }
            },
            function (error) {
              console.log("Error Code = eoo " + error.code + " - " + error.message);
            });
        } else {
          console.log("Not Available");
        }
      }
      this.setState({
        locations: locations,
        defaultLocations: locations
      });
    })
  }

  getCommons(){
    axios.get(process.env.REACT_APP_API_URL+'commons').then(res => {
      const specialties = res.data.map((common) => {
        common._label = common.name;
        return { value: common, label: common.name }
      });
      this.setState({ specialties });
    })
  }

  getExpertColumns(){
    healthTipService.getHealthTips().then(
        res => {
            if(_.has(res, 'health_tips')){
                const expert_columns = res.health_tips;
                const expert_column_items = expert_columns.slice(0, 3);
                this.setState({ expert_column_items });
            }
        },
        error => {
          console.log('There has been a problem with your fetch operation: ', error.message);
        }
    )
  }
  
  handleCategoryChange(category) {
    if(category === 'deeplink'){
      window.open(`${process.env.REACT_APP_DEEPLINK_URL}/search-book/doctor/`, '_blank','noopener,noreferrer');
    }else{
      this.setState(() => ({
        selected_category: category,
        loading: true
      }));

      // call api to update sections
      let params = {
        specialty_name: category,
        perpage: 4,
        pageindex: 1,
        date: moment().format('YYYYMMDD'),
        around: 1
      }

      var current_location = this.state.defaultLocations.find((e) => e.type === 'current_location');
      if(current_location){
        params.lat = current_location.lat;
        params.long = current_location.long;
      }

      doctorService.searchDoctors(params)
      .then(
        data => {
          if(data){
            this.setState({
              healthcare_professionals: data.doctors
            });
          }
        },
        error => {
          if (typeof error.json === "function") {
            error.json().then(jsonError => {
              this.setState({
                error_result: jsonError.error
              });
            });
          } else {
            this.setState({
              error_result: 'Internal Server Error'
            });
            console.log('There has been a problem with your fetch operation: ',error.message);
          }
        }
      ).then(() => {
        this.setState({
          loading: false
        });
      });
    }
  }

  handleSpecialtySelectChange = selectedValue => {
    selectedValue.label = selectedValue.value._label;

    this.setState({
        selected_specialty: selectedValue,
        search_input_value: selectedValue.label
    });

    var locationField = document.getElementById("locationField");
    var dateField = document.getElementById("dateField");

    if(selectedValue.value.type === 'doctor' && selectedValue.value.id !== -1){
        locationField.classList.add("disabled");
        dateField.classList.remove('disabled');

    }else if(selectedValue.value.type === 'facility' && selectedValue.value.id !== -1){
        locationField.classList.add("disabled");
        dateField.classList.add("disabled");
    }else{
        locationField.classList.remove("disabled");
        dateField.classList.remove("disabled");
    }
  };
  handleSpecialtyInputChange = (newValue, { action }) => {
    if (action === "input-change"){
      this.setState({
        search_input_value: newValue,
        selected_specialty: null
      });
      return newValue;
    }
  };
  renderSuggestionType(suggestion) {
    switch(suggestion.type) {
      case 'common_name':
        return "Layman's Term";
      default:
        return suggestion.type;
    }
  }

  renderSuggestionName(suggestion){
    if(suggestion.type === 'doctor' && suggestion.id === -1){
      return `Doctors named "${this.state.search_input_value}" (${suggestion.count})`;
    }else if(suggestion.type === 'facility' && suggestion.id === -1){
      return `Facilities named "${this.state.search_input_value}" (${suggestion.count})`;
    }
    else{
      return suggestion.name;
    }
  }

  handleLocationSelectChange = (selectedLocation, {action}) => {
    if(action === 'clear'){
      this.setState({
        locations: this.state.defaultLocations,
        location: '',
        selected_location_display: ''
      })
    }else{
      if(selectedLocation.type === 'available_country'){
        if(selectedLocation.states === null){
          this.setState({
            location: selectedLocation,
            selected_location_display: selectedLocation
          });
        }else{
          var states = selectedLocation.states;
          var checkAllExist = states.findIndex(x => x.type === 'all_states')
          if (checkAllExist < 0) {
            states.unshift({
              name: 'All',
              type: 'all_states'
            })
          }
          this.setState({
            location: selectedLocation,
            selected_location_display: selectedLocation,
            locations: [{
              label: selectedLocation.name,
              type: 'state',
              options: states
            }]
          });
        }
      }
      else if(selectedLocation.type === 'current_location'){
        this.setState({
          location: selectedLocation,
          selected_location_display: selectedLocation
        });
      }else{
        this.setState({
          selected_state: selectedLocation,
          selected_location_display: {
            name: `${this.state.location.name}/${selectedLocation.name}`,
            value: selectedLocation
          }
        });
      }
    }
  };

  getAvailableDate = (date) => {
    if(date){
      var today = moment().format('ddd, MMM DD');
      var tomorrow = moment().add(1,'days').format('ddd, MMM DD');
      date = moment(date, 'YYYY-MM-DD').format('ddd, MMM DD');

      if(date === today){
        return 'Today';
      }else if(date === tomorrow){
        return 'Tomorrow';
      }else{
        return date;
      }
    }else{
      return '-';
    }
  }

  submitForm = (e) => {
    e.preventDefault();
  
    if (!_.has(this.state.selected_specialty, 'value') || this.state.selected_specialty.value.type !== 'facility' || this.state.selected_specialty.value.id === -1) {
      this.props.history.push({
        pathname: '/search-book/result',
        state: this.state
      });
    } else {
      this.props.history.push({
        pathname: `/search-book/clinic/${this.state.selected_specialty.value.friendly_id}`
      });
    }
  }

  displayHealthCareProfessionals = (doc, index) => {
    return <div className="healthcare-professionals-col" key={`healthcare-col-${index}`}>
      <img src={`${doc.avatar ? (doc.avatar.url.thumb.url) : default_avatar}`} onError={(e) => { e.target.src = default_avatar }} alt='profile-avatar' className="w-100 healthcare-img"/>
      <div className="details">
        <div className="name">{doc.title || ''} {doc.name}</div>
        <div className="specialty">{this.state.selected_category}</div>
        <div className="location-container">
          <div className="location-details-container">
            <img className="location-icon" src={locationIcon} alt="location"/>
            <div className="location-details">
              <div className="location-name">{doc.location.name}</div>
              <div className="location-state">{doc.location.city}, {doc.location.country}</div>
            </div>
          </div>
          <div className="availability-container">
            <img className="calendar-icon" src={calendarIcon} alt="calendar"/>
            <div className="availability">Appointments available <span className="date">{this.getAvailableDate(doc.available_date)}</span></div>
          </div>
        </div>
        <a className="btn book-btn" href={`/search-book/professional-profile/${doc.friendly_id}/${doc.location.friendly_id}`} target="_blank" rel="noreferrer">View</a>
      </div>
    </div>;
  }

  displayHealthArticle = (expert_column, index) => {
    return <div className="expert-columns-col" key={`healthcare-col-${index}`} onClick={() => window.location.href = `/search-book/expert-column/${expert_column.id}`}>
      <div className="healthcare-img-container">
        <div className="background-image"/>
        <img src={`${expert_column.image.cover || default_avatar}`} onError={(e) => { e.target.src = default_avatar }} alt='profile-avatar' className="w-100 healthcare-img"/>
      </div>
      <div className="details">
        <div className="col-title">{expert_column.title}</div>
        <div className="author">{expert_column.author}</div>
        {/* <div dangerouslySetInnerHTML={{ __html: expert_column.short_description }} className="short-description"/> */}
        <div className="read-more-btn">Read More <i className="fa-solid fa-caret-right"></i></div>
      </div>
    </div>;
  }

  getMapDoctors = async () => {
    const category = "General Practitioner (GP Doctor)";
    this.setState(() => ({
      selected_category: category,
      map_loading: true,
      map_doctors: [], // Reset map_doctors to avoid appending old data
    }));
  
    // Base parameters for the API request
    const params = {
      specialty_name: category,
      perpage: 500,
      pageindex: 1,
      country_id: 2
    };
  
    try {
      let totalPages = 1;
  
      // Fetch data for each page
      while (params.pageindex <= totalPages) {
        const data = await doctorService.searchDoctors(params);
  
        if (data) {
          // Update state incrementally with each page of data
          this.setState((prevState) => ({
            map_doctors: [...prevState.map_doctors, ...data.doctors],
            map_loading: false
          }));
  
          // Update totalPages based on the response
          totalPages = data.meta.total_pages;
  
          // Move to the next page
          params.pageindex++;
        }
      }
    } catch (error) {
      if (typeof error.json === "function") {
        const jsonError = await error.json();
        this.setState({
          error_result: jsonError.error,
        });
      } else {
        this.setState({
          error_result: "Internal Server Error",
        });
        console.error("There has been a problem with your fetch operation:", error.message);
      }
    } finally {
      this.setState({
        map_loading: false,
      });
    }
  };
  
  render() {
    const HighlightSubstring = ({ text, substring }) => {
      if (!substring) return <span>{text}</span>;
    
      const parts = text.split(new RegExp(`(${substring})`, "gi")); // Split by the substring (case-insensitive)
    
      return (
        <span>
          {parts.map((part, index) =>
            part.toLowerCase() === substring.toLowerCase() ? (
              <b key={index}>{part}</b> // Bold the matching substring
            ) : (
              part // Render non-matching parts normally
            )
          )}
        </span>
      );
    };

    const promiseOptions = inputValue =>
      new Promise((resolve, reject) => {
        if (inputValue.length >= 2) {
          axios.get(`${process.env.REACT_APP_API_URL}suggestions?keyword=${encodeURIComponent(inputValue)}`).then(res => {
            resolve(res.data.map((suggestion) => {
              if (suggestion.id === -1 && (suggestion.type === 'doctor' || suggestion.type === 'facility')) {
                suggestion.count = suggestion.name
                suggestion.name = this.state.search_input_value
              }
              suggestion._label = this.renderSuggestionName(suggestion)
              return {
                value: suggestion,
                label: ( <div className = "label specialty-label" >
                  <span className = "suggestion-name" > {
                    <HighlightSubstring text={this.renderSuggestionName(suggestion)} substring={inputValue} />
                  } </span> <span className = "suggestion-type" > {
                    this.renderSuggestionType(suggestion)
                  } </span></div > )
              }
            }))
          })
        } else {
          resolve([]);
        }
    });

    return (
      <div className="new-home-page">
        <SEO 
        title={this.state.metadata.title} 
        description={this.state.metadata.description}
        type={this.state.metadata.type} />
        
          <div className="main-section homepage-wrapper">
            <div className="main-descriptions-container">
              <div className="main-descriptions">
                <h1 className="main-title">Connecting You With Healthcare Professionals</h1>
                <p className="main-subtitle">Search & Book your appointments the easy way!</p>
              </div>
              <div className="main-img">
                <img src={main_img} alt="Search & Book"/>
              </div>
            </div>
            <div className="search-container">
              <InputGroup className="mb-3">
                <AsyncSelect className="speciality-field floating-label-field" placeholder="Specialty, Service, Doctor, Clinic, etc." cacheOptions loadOptions={promiseOptions} defaultOptions={this.state.specialties} onInputChange={this.handleSpecialtyInputChange} onChange={this.handleSpecialtySelectChange} defaultValue={this.state.selected_specialty} inputValue={this.state.search_input_value} value={this.state.selected_specialty} closeMenuOnSelect={true}/>
                
                <Select id="locationField" className="location-field floating-label-field" options={this.state.locations} getOptionLabel={(option)=>option.name} getOptionValue={(option)=>option} placeholder="Select Location" onChange={this.handleLocationSelectChange} closeMenuOnSelect={this.state.closeLocationField} isClearable={true} value={this.state.selected_location_display}/>

                <div className="date-group">
                  <DatePicker id="dateField" className="form-control date-field floating-label-field" minDate={new Date()} dateFormat="dd/MM/yyyy" selected={this.state.startDate} onChange={date => this.setState({ startDate: date })} placeholder="Date" />
                  <div className="custom-calendar-icon"></div>
                </div>
                
                <InputGroup.Append>
                  <input className="btn search-btn" type="button" value="Search" onClick={this.submitForm}/>
                </InputGroup.Append>
              </InputGroup>
            </div>

            <div className="specialties-section">
              <div className="specialties-container homepage-wrapper">
                <h2 className="title">Most Searched <span className="subtitle">Specialties</span></h2>
                <div className="specialties-row">
                  {
                    this.specialties.map((value, index) => (
                      <div className="specialty-col" key={`specialty-${index}`}>
                        <img src={value.img} alt={value.name}/>
                        <p className="specialty-name" dangerouslySetInnerHTML={{__html: value.name}} />
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>

            <div className="healthcare-providers-container">
              <div className="title">FEATURED HEALTHCARE PROVIDERS</div>
              <Slider />
            </div>
          </div>

          <div className="map-section">
            <div className="homepage-wrapper">
              <h2 className="title">Find healthcare professionals near you.</h2>
              <h3 className="subtitle">Easily search and book appointments with qualified healthcare professionals in your area.</h3>
              <div className="map-container">
                {(() => {
                  if (this.state.map_loading) {
                    return <Spinner animation="border" className="spinner"/>;
                  } else {
                    return (
                      <HomeMap results={this.state.map_doctors} parentName={`ResultMapView`}/>
                    )
                  }
                })()}
                {/* {this.state.map_doctors.length > 0 && 
                  <HomeMap results={this.state.map_doctors} parentName={`ResultMapView`}/>
                } */}
              </div>
            </div>
          </div>

          <div className="healthcare-professionals-section">
            <div className="homepage-wrapper">
              <h2 className="title">Your Trusted Experts, Always Reliable</h2>
              <div className="categories-row">
                {
                  this.categories.map((category, index) => (
                    <button className={`category-col btn ${this.state.selected_category === category.value ? 'active' : ''}`} key={`category-${index}`} onClick={() => this.handleCategoryChange(category.value)}>
                      {category.label}
                    </button>
                  ))
                }
              </div>
              <div className="healthcare-professionals-row">
                {(() => {
                  if (this.state.loading) {
                    return <Spinner animation="border" className="spinner"/>;
                  } else {
                    return (
                      <div className="w-100">
                        <Carousel fade className="mobile-version" controls={false} interval={null}>
                          {this.state.healthcare_professionals.map((doc, index) => (
                            <Carousel.Item key={`carousel-${index}`}>
                              {this.displayHealthCareProfessionals(doc,index)}
                            </Carousel.Item>
                          ))}
                        </Carousel>
                        <div className="desktop-version">
                          {this.state.healthcare_professionals.map((doc, index) => (
                            this.displayHealthCareProfessionals(doc,index)
                          ))}
                        </div>
                      </div>
                      )
                  }
                })()}
              </div>
            </div>
          </div>

          <div className="expert-column-section">
            <div className="homepage-wrapper">
              <div className="section-header d-flex justify-content-between align-items-center">
                <h2 className="title">Expert Columns</h2>
                <a href="/search-book/expert-column" className="view-more-btn desktop">View More</a>
                <a href="/search-book/expert-column" className="view-more-btn mobile-version">
                  <img className="right-icon w-50" src={rightIcon} alt="rightIcon"/>
                </a>
              </div>
              <div className="row justify-content-center top-part">
                <div className="center-content w-100">
                    <div className="expert-columns-row">
                      <div className="w-100">
                        <Carousel fade className="mobile-version" controls={false} interval={null}>
                          {this.state.expert_column_items.map((expert_column, index) => (
                            <Carousel.Item key={`expert-column-carousel-${index}`}>
                              {this.displayHealthArticle(expert_column,index)}
                            </Carousel.Item>
                          ))}
                        </Carousel>
                        <div className="desktop-version">
                          {this.state.expert_column_items.map((expert_column, index) => (
                            this.displayHealthArticle(expert_column,index)
                          ))}
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
      
          <div className="practice-section">
            <div className="homepage-wrapper">
              <div className="practice-container">
                <div className="practice-img">
                  <img src={practice_img} alt="Are you a healthcare professional?"/>
                </div>
                <div className="practice-details">
                  <h2 className="title">Are you a Healthcare Professional?</h2>
                  <h3 className="subtitle">List your practice today to gain access to a wider network of patients and our exclusive doctors' portal.</h3>
                  <a className="btn practice-btn" href="/who-we-serve/healthcare-providers/list-your-practice" target="_blank">List Your Practice</a>
                </div>
              </div>
            </div>
          </div>
      </div>
    );
  };
}

export { Home };